import React from 'react';
import AssociateDish from '../AssociateDish';
import { Modal } from 'wix-style-react';

export default function AssociateDishModal({ isOpen, toggleAssociation, ...rest }) {
  return (
    <Modal isOpen={isOpen} onRequestClose={rest.onRequestClose} shouldCloseOnOverlayClick>
      {isOpen && <AssociateDish {...rest} onChange={toggleAssociation} />}
    </Modal>
  );
}

AssociateDishModal.displayName = 'AssociateDishModal';
